export default "__VITE_ASSET__PHdABNTy__"